export const isContractorPath = (pathname: string) =>
  pathname.includes('/contractor');

export const isInternalPath = (pathname: string) => !isContractorPath(pathname);

export const isContractorPortal = (): boolean =>
  isContractorPath(window.location.pathname);
